import { generateURL } from 'gw-portals-url-js';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';

function generateDownloadURL(serviceEndpoint, documentID, token) {
    const getUrl = window.location;
    const baseUrl = `${getUrl.origin}/${getUrl.pathname.split('/')[1]}`;
    const redirectRoute = _.get(appConfig, 'documentNotFoundRedirectUrl') || '';
    const params = {
        urlParam: documentID,
        token,
        portalRoute: `${baseUrl}/${redirectRoute}`
    };
    return generateURL(serviceEndpoint, params);
}

export default class DocumentDownloadService {
    static getDocumentLink(serviceEndpoint, documentID, token) {
        return generateDownloadURL(serviceEndpoint, documentID, token);
    }

    static getDocument(downloadEndpointURL, authHeader, errorCallback = _.noop) {
        const params = {
            method: 'GET',
            url: downloadEndpointURL,
            headers: {
                ...authHeader,
                'Content-Type': 'application/json'
            },
            responseType: 'arraybuffer'
        };
        return fetch(downloadEndpointURL, params).then((response) => {
            if (response.ok) {
                response.blob().then((blob) => {
                    const filename = response.headers.get('Content-Disposition').replace('attachment; filename=', '');
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, filename);
                    } else {
                        const downloadLink = document.createElement('a');
                        downloadLink.setAttribute('href', window.URL.createObjectURL(blob));
                        downloadLink.setAttribute('download', filename);
                        downloadLink.style.display = 'none';
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        downloadLink.remove();
                    }
                });
            } else errorCallback();
        }).catch(() => {
            errorCallback();
        });
    }
}
